// routes/forgot-password_.reset.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/forgot-password.reset')

export const handle = { name: 'forgot-password/reset' }

export default dynamic(getClientModule, { ssr: false })
